// components/client/ToastifyClient.jsx
"use client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ToastifyClient() {
  return (
    <ToastContainer
      containerId="global"
      position="top-right"
      newestOnTop
      closeOnClick={false}
      draggable={false}
      pauseOnHover
      limit={8}
      theme="dark"
    />
  );
}
